import React, { useRef, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2, ImagePlus, Video, Mic } from "lucide-react";

export function MediaUploader({ accept = "image/*", label = "Add photo", kind = "image", onUploaded, testid }) {
  const ref = useRef();
  const [loading, setLoading] = useState(false);

  const pick = () => ref.current?.click();

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(data.path);
      toast.success("Uploaded");
    } catch {
      toast.error("Upload failed");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const Icon = kind === "video" ? Video : kind === "audio" ? Mic : ImagePlus;

  return (
    <>
      <input ref={ref} type="file" accept={accept} onChange={onChange} className="hidden" data-testid={testid ? `${testid}-input` : undefined} />
      <button type="button" onClick={pick} disabled={loading}
        data-testid={testid}
        className="flex items-center gap-2 rounded-xl px-4 py-3 text-sm w-full justify-center gold-border"
        style={{ background: "var(--overlay)", color: "var(--text-secondary)" }}>
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Icon size={16} className="gold-text" />}
        {loading ? "Uploading…" : label}
      </button>
    </>
  );
}
